import styled from 'styled-components';

export default styled.div`
  form {
    display: block;
  }
  .Mui-disabled {
    color: #ccc !important;
  }
  .coupons-setting-box {
    border-radius: 12px;
    background-color: #fff;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 0 24px;
  }
  .coupons-setting-box-4fr {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 48px;
  }
  .coupons-setting-box-display-flex {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    .MuiFormControlLabel-root {
      min-width: 0;
      margin-right: 0;
    }
  }
  .coupons-setting-box-3fr {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  }
  .coupons-setting-box-2fr {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
    .MuiFormControlLabel-root {
      margin-right: 0;
      min-width: auto;
    }
  }
  .params-icon-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fafafa;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
  }
  .radio-text-wrap {
    display: flex;
    position: relative;
    top: 5px;
  }
  .radio-text-end-text {
    position: relative;
    top: 5px;
    left: 4px;
    color: #333;
  }
  .required-text {
    color: #d10000;
    display: inline-block;
    width: 7px;
    font-size: 12px;
  }
  .title-text-wrap {
    font-size: 16px;
    color: #333333;
    margin-bottom: 12px;
    height: 22px;
    line-height: 22px;
  }
  .third-coupon-card {
    width: 100%;
    height: 122px;
    gap: 16px;
    angle: 0 deg;
    opacity: 1;
    border-radius: 8px;

    border: 1px solid #e5e5e5;
    background: #f9f9f9;
    .third-coupon-control {
      border-radius: 8px;
      position: relative;
      padding: 16px 30px 16px 16px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .third-coupon-info {
        display: flex;
        gap: 8px;
        align-items: center;
        .third-coupon-label {
          height: 22px;
          line-height: 22px;
          border-radius: 4px;
          padding-top: 1px;
          padding-right: 4px;
          padding-bottom: 1px;
          padding-left: 4px;
          background-color: #eee;
          font-family: PingFang SC;
          font-weight: 400;
          font-style: Regular;
          font-size: 14px;
          leading-trim: NONE;
          letter-spacing: 0px;
          color: #777;
        }
      }
      .third-coupon-tag {
        width: 26px;
        position: absolute;
        top: 4px;
        right: 4px;
        bottom: 4px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        border-radius: 6px;
        span {
          font-family: PingFang SC;
          font-weight: 500;
          font-style: Medium;
          font-size: 16px;
          leading-trim: NONE;
          letter-spacing: 0.2px;
          color: #ccc;
          transform: rotateZ(90deg);
        }
      }
    }
  }
  .third-coupon-card-data {
    .third-coupon-control {
      border: 1px solid #badbff;
      background: #f7fbff;
      .third-coupon-info {
        .third-coupon-label {
          width: 78px;
          border-radius: 4px;
          text-align: center;
          border: 0.5px solid #65a7f0;
          background: #f7fbff;
          color: #65a7f0;
          flex-shrink: 0;
          padding: 0;
        }
        .third-coupon-content {
          height: 20px;
          line-height: 20px;
          font-weight: 400;
          font-size: 14px;
          color: #111;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .third-coupon-tag {
        background: #badbff;
        span {
          color: #fff;
        }
      }
    }
  }
  .third-coupon-delete {
    width: 68px;
    color: #f50057;
    border: 1px solid #f50057;
    background-color: transparent;
  }
  .third-coupon-delete:hover {
    background-color: transparent;
  }
  .third-coupon-change {
    width: 68px;
    color: #1565c0;
    border: 1px solid #1565c0;
    background-color: transparent;
    margin-right: 12px;
  }
  .third-coupon-change:hover {
    background-color: transparent;
  }
  .file_name {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    background-color: ${(props) =>
      props.queryType === 'detail' ? '#fff' : '#e0e0e0'};
    border-radius: 16px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;
